module.exports = __webpack_public_path__ + "static/media/icon-text-grey.eb673a47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-text-grey.svg
// module id = 932
// module chunks = 0